import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {}
}

export default createCrudModule({
  client: api.client,
  resource: 'projectUsers',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn: (id, params) => `/projects/${params.project_id}/users${id ? '/'+id : ''}`,
  state
});